'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _unauthorized = require('./unauthorized');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.authorization', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider
    //.state('sso', {
    //    url: '/sso/:responsedata',
    //    skipAuthentication: true,
    //    resolve: {
    //        auth: function ($rootScope, $state, $location, $stateParams, authService) {
    //            'ngInject';
    //            //send the user to the correct page if they are authenticated/chose a tenant
    //            return authService.processSsoResponseData($location.absUrl())
    //                .then(function(result) {
    //                    if (result.isTenantChanged) {
    //                        $state.go('home', { language: 'nl', isTenantChanged: true });
    //                    }
    //                    else if (!result.hasCurrentTenant && result.toState !== 'unauthorized') {
    //                        if(authService.identity.tenants.length === 1) { // if there is one tenant automaticly choose that one
    //                            authService.signInWithTenant(authService.identity.tenants[0].secondaryAppUserKey, false);
    //                        } 
    //                        else {  //else show the select tenant screen
    //                            $state.go('login');
    //                        }
    //                    }
    //                    else {
    //                        $state.go(result.toState, result.toParams);                                 
    //                    }       
    //                })
    //                .catch(function() {
    //                    $state.go('unauthorized');
    //                });
    //        }
    //    }
    //})
    .state('unauthorized', {
        url: '/unauthorized',
        parent: 'master',
        views: {
            'main@root': {
                component: 'unauthorized'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': ''
        },
        data: {
            public: true
        }
    });
}]).component('unauthorized', _unauthorized.unauthorizedComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/authorization/index.js
// module id = 893
// module chunks = 0